// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"app-components-browse-sortmode--wrapper","disabled":"app-components-browse-sortmode--disabled","sortSelect":"app-components-browse-sortmode--sortSelect"};